// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"6b8424a6","53":"e84322a7","217":"67bc0d21","337":"79e802ac","451":"0a1be5d9","510":"05d5848f","604":"189c15fe","622":"8113b1a5","708":"19ef00b9","743":"eb8cd8c7","751":"42e22c09","791":"2dd28129","800":"22df66f1","821":"938eb88d","827":"978e3851"}[chunkId] + ".chunk.js";
};